<div class="dialog-form">
    <app-table-verify-contracts [documents]="documents"></app-table-verify-contracts>
    <div class="form-group">
        <div class="buttons">
            <button class="easymarine primary" type="button"
                (click)="dialogRef.close()">Fechar</button>
        </div>
    </div>
</div>